var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    _vm._l(_vm.riskPolicy, function (value, key) {
      return _c("div", { key: key }, [
        !_vm.nonEditableFields.includes(key)
          ? _c(
              "div",
              { staticClass: "columns" },
              [
                _c("div", { staticClass: "column" }, [_vm._v(_vm._s(key))]),
                typeof value === "boolean"
                  ? _c("b-switch", {
                      staticClass: "column",
                      attrs: { disabled: _vm.isLoading, value: value },
                      on: {
                        input: function ($event) {
                          return _vm.updateRiskPolicy(_vm.riskPolicy._id, {
                            [key]: $event,
                          })
                        },
                      },
                    })
                  : typeof value === "number"
                  ? _c("b-numberinput", {
                      staticClass: "number-input column",
                      attrs: {
                        value: value,
                        size: "is-small",
                        "controls-rounded": "",
                        rounded: "",
                        disabled: _vm.isLoading,
                      },
                      nativeOn: {
                        keyup: function ($event) {
                          if (
                            !$event.type.indexOf("key") &&
                            _vm._k(
                              $event.keyCode,
                              "enter",
                              13,
                              $event.key,
                              "Enter"
                            )
                          )
                            return null
                          return _vm.updateRiskPolicy(_vm.riskPolicy._id, {
                            [key]: $event.target.valueAsNumber,
                          })
                        },
                      },
                    })
                  : _c("div", { staticClass: "column" }, [
                      _vm._v(_vm._s(value)),
                    ]),
              ],
              1
            )
          : _vm._e(),
      ])
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }